<template>
  <div>
    <div class="loader-wrapper">
      <div class="loader-index"><span></span></div>
      <svg>
        <defs></defs>
        <filter id="goo">
          <fegaussianblur in="SourceGraphic" stddeviation="11" result="blur"></fegaussianblur>
          <fecolormatrix in="blur" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9" result="goo"></fecolormatrix>
        </filter>
      </svg>
    </div>
  </div>
</template>

<script>
import authService from '@/services/authService';

export default {
  name: 'Logout',
  
  /**
   * Ejecutar logout automáticamente al montar el componente
   */
  mounted() {
    this.performLogout();
  },

  methods: {
    /**
     * Realizar el proceso completo de logout
     */
    performLogout() {
      try {
        // Limpiar toda la sesión almacenada
        authService.logout();
        
        // Mostrar mensaje informativo (opcional)
        console.log('Sesión cerrada exitosamente');
        
        // Redirigir al landing después de un breve delay
        setTimeout(() => {
          this.$router.push('/');
        }, 500);
        
      } catch (error) {
        console.error('Error durante el logout:', error);
        // Incluso si hay error, redirigir al landing
        this.$router.push('/');
      }
    }
  }
};
</script>

<style scoped>
</style>
